import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const HeartFilledIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M6 9.82353C6 7.71186 7.49239 6 9.33333 6C10.4237 6 11.3918 6.60055 12 7.52904C12.6082 6.60055 13.5763 6 14.6667 6C16.5076 6 18 7.71186 18 9.82353C18 13.2318 12 17 12 17C12 17 6 13.2318 6 9.82353Z"
        fill={fillColor || '#111112'}
      />
    </svg>
  );
};

export { HeartFilledIcon };
